// Cricket scorelines: runs live in score_a/score_b; wickets_* (0-10) and overs_* ("18.4") are optional extras.
export const OVERS_RE = /^\d{1,3}(\.[0-5])?$/;

export const isCricket = (sport) => (sport || '').toLowerCase() === 'cricket';

const blank = (v) => v === null || v === undefined || v === '';

// "192/4" (or "192" with no wickets).
export const runsWickets = (runs, wickets) => (blank(runs) ? '' : blank(wickets) ? `${runs}` : `${runs}/${wickets}`);

export const sideRuns = (m, side) => runsWickets(m?.[`score_${side}`], m?.[`wickets_${side}`]);
export const sideOvers = (m, side) => m?.[`overs_${side}`] || '';

// Full form: "192/4 (18.4 Overs)".
export const cricketLine = (m, side) => {
  const base = sideRuns(m, side);
  const ov = sideOvers(m, side);
  return base && ov ? `${base} (${ov} Overs)` : base;
};

// Returns an error message, or null when the cricket inputs for one side are valid.
export function cricketSideError(name, wickets, overs) {
  if (blank(wickets)) return `Enter the wickets for ${name} (0-10)`;
  const w = Number(wickets);
  if (!/^\d+$/.test(String(wickets).trim()) || w > 10) return `Wickets for ${name} must be 0 to 10`;
  if (!blank(overs) && !OVERS_RE.test(String(overs).trim())) return `Overs for ${name} must look like 18 or 18.4 (up to 5 balls after the dot)`;
  return null;
}

export const cricketPayload = (wA, wB, oA, oB) => ({
  wickets_a: parseInt(wA, 10),
  wickets_b: parseInt(wB, 10),
  overs_a: String(oA || '').trim() || null,
  overs_b: String(oB || '').trim() || null,
});

export const formatNrr = (v) => (v === null || v === undefined ? '–' : `${v > 0 ? '+' : ''}${Number(v).toFixed(3)}`);
